
import React from "react";

interface RequirementTypeProps {
  type: string | undefined | null;
}

export function RequirementType({ type }: RequirementTypeProps) {
  if (!type) return <span className="text-muted-foreground text-xs">-</span>;
  
  const isOptional = type.toLowerCase() === 'optional';
  
  return (
    <div className="space-x-2">
      {isOptional ? (
        <span className="inline-block bg-[#F2FCE2] text-green-800 rounded px-2 py-0.5 text-xs">
          Optional
        </span>
      ) : (
        <span className="inline-block bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300 rounded px-2 py-0.5 text-xs">
          {type}
        </span>
      )}
    </div>
  );
}
